import { render } from "./list-log.vue?vue&type=template&id=4b54b3cf"
import script from "./list-log.vue?vue&type=script&lang=js"
export * from "./list-log.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__